/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B5_DInputs */

const en_mk_abt_b5_d = /** @type {(inputs: Mk_Abt_B5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This product was written in Indonesian first, including the agents’ own built-in instructions. English is fully available, but it is not the original.`)
};

const id_mk_abt_b5_d = /** @type {(inputs: Mk_Abt_B5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produk ini ditulis dalam bahasa Indonesia lebih dulu, termasuk instruksi bawaan agennya. Inggris tersedia penuh, tapi bukan bahasa aslinya.`)
};

/**
* | output |
* | --- |
* | "This product was written in Indonesian first, including the agents’ own built-in instructions. English is fully available, but it is not the original." |
*
* @param {Mk_Abt_B5_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b5_d = /** @type {((inputs?: Mk_Abt_B5_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B5_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b5_d(inputs)
	return en_mk_abt_b5_d(inputs)
});